export default [
    [
        { text: 'электричество', model: 'hasElectricity' },
        { text: 'канализация', model: 'hasDrainage' },
        { text: 'водоснабжение', model: 'hasWater' },
    ], [
        { text: 'газ', model: 'hasGas' },
        { text: 'охрана', model: 'hasSecurity' },
        { text: 'телефон', model: 'hasPhone' },
    ], [
        { text: 'баня', model: 'hasBathhouse' },
        { text: 'гараж', model: 'hasGarage' },
        { text: 'бассейн', model: 'hasPool' },
    ],
];
